import { IconButton, InputAdornment } from '@material-ui/core';
import { GREY_100 } from 'assets/theme/colors';
import FormControlTextField from 'modules/common/FormControlTextField';
import { ReactComponent as IcSearch } from '../../../assets/icons/ic_search.svg';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { some } from 'constants/constants';

interface Props {
  onSearch(searchInput: string): void;
  results?: some;
  hideLogo: boolean;
  setHideLogo: (value: boolean) => void;
}

const MobileSearchBox: React.FC<Props> = (props) => {
  const { onSearch } = props;
  const intl = useIntl();
  const [searchInput, setSearchInput] = React.useState<string>('');

  return (
    <div>
      <FormControlTextField
        style={{
          background: GREY_100,
          minWidth: 316,
          width: '100%',
          position: 'relative',
          minHeight: '48px',
          transition: 'all .5s',
        }}
        id="searchInput"
        disableError
        placeholder={intl.formatMessage({ id: 'home.enterBookerCode' })}
        formControlStyle={{ margin: 0, minHeight: 0 }}
        value={searchInput}
        onChange={(e: any) => {
          setSearchInput(e.target.value);
        }}
        startAdornment={
          <InputAdornment position="start" style={{ marginLeft: 8 }}>
            <IconButton size="small" edge="start">
              <IcSearch />
            </IconButton>
          </InputAdornment>
        }
        optional
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSearch(searchInput);
        }}
        helpTextStyle={{ minHeight: 0 }}
      />
    </div>
  );
};

export default MobileSearchBox;
